// Module
var code = "<div class=\"container\"><div class=\"step-wrap\"><h1 class=\"step-title\">We look forward to seeing you!</h1><p>Thanks Christine, in the next few minutes, you should receive the confrirmation at <strong>christina.davidson@gmail.com</strong>.</p></div><br /></div>\n";
// Exports
module.exports = code;